import {Injectable} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

@Injectable()
export class UserFormService {
  userForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.userForm = this.createFormGroup();
  }


  public getUserForm(): FormGroup {
    return this.userForm;
  }

  public setAdminControls() {
    this.userForm.addControl(
      'address',
      new FormControl('', Validators.compose([Validators.required, Validators.minLength(50)])));
    this.userForm.addControl(
      'phone',
      new FormControl('', Validators.compose([Validators.required, Validators.minLength(50)])));

  }

  public createFormGroup(): FormGroup {
    this.userForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'lastName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'userRoleId': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ]
      // 'address': [
      //   null,
      //   Validators.compose([
      //     Validators.required,
      //     Validators.maxLength(50)
      //   ])
      // ],
      // 'phone': [
      //   null,
      //   Validators.compose([
      //     Validators.required,
      //     Validators.maxLength(50)
      //   ])
      // ],
    });
    return this.userForm;
  }
}



// WEBPACK FOOTER //
// ./src/app/user/shared/user-form.service.ts